export default class Constant {
   static successFullySaved = "Saved Successfully"
   static failToSave = "Fail to Save"
   static successfullyDeleted = "Deleted Successfully"
   static failToDelete = "Fail to Delete"
   static successActive = "Status Updated Successfully"
   static failedToActive = "Fail to Update"
   static updateStatus = "Updated Successfully"
   static failedUpdateStatus = "Failed to update"
}
